<!-- src/app/features/wizard/form/form.component.html -->
<div class="form-page-container">
  <div class="form-header-bar" *ngIf="!isOnboarding">
    <button mat-icon-button (click)="goBack()" title="Zurück zur Liste">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <div class="header-titles">
      <h1 class="mat-h2">{{ shapeName || 'Formular ausfüllen' }}</h1>
    </div>
  </div>

  <div class="form-content-wrapper">
    <app-error *ngIf="error" [message]="error"></app-error>
    <app-loading *ngIf="loading" [message]="'Formulardefinition wird geladen...'"></app-loading>

    <mat-card *ngIf="!loading && !error && shape" class="form-card">
      <mat-card-header>
        <div class="header-container">
          <div class="shape-info">
            <mat-card-subtitle *ngIf="shapeDescription && !isOnboarding">{{ shapeDescription }}</mat-card-subtitle>
          </div>
          <div class="pagination-control">
            <mat-form-field appearance="outline" class="fields-per-page">
              <mat-label>Felder pro Seite</mat-label>
              <mat-select [(ngModel)]="fieldsPerPage" [ngModelOptions]="{standalone: true}">
                <mat-option *ngFor="let opt of fieldsPerPageOptions" [value]="opt">
                  {{ opt }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </mat-card-header>

      <mat-card-content>
        <form [formGroup]="form" (ngSubmit)="onSubmit()" class="wizard-form">

          <ng-container *ngIf="!hasOverflow">
            <div class="form-fields-container">
              <app-form-field *ngFor="let field of fields" [field]="field" [formGroup]="form" [initialValue]="getPrefillValue(field)"></app-form-field>

              <div class="optional-fields-trigger" *ngIf="showOptionalButton">
                <button mat-stroked-button color="accent" type="button" (click)="toggleOptionalFields()">
                  <mat-icon>add</mat-icon>
                  Description and Relationships hinzufügen
                </button>
              </div>
            </div>
          </ng-container>

          <!-- Legal Person Stepper -->
          <mat-horizontal-stepper *ngIf="hasOverflow && isLegalPerson" #stepper [linear]="false" class="form-stepper">
            <!-- Name Step -->
            <mat-step [stepControl]="form" *ngIf="fields[0]">
              <ng-template matStepLabel>Name</ng-template>
              <div class="form-fields-container single-field">
                <app-form-field [field]="fields[0]" [formGroup]="form" [initialValue]="getPrefillValue(fields[0])"></app-form-field>
              </div>
              <div class="stepper-actions">
                <button mat-raised-button color="primary" type="button" matStepperNext>Weiter
                  <mat-icon>arrow_forward</mat-icon></button>
              </div>
            </mat-step>

            <!-- Registration Number Step -->
            <mat-step [stepControl]="form" *ngIf="fields[1]">
              <ng-template matStepLabel>Registrierungs-Nummer</ng-template>
              <div class="form-fields-container single-field">
                <app-form-field [field]="fields[1]" [formGroup]="form" [initialValue]="getPrefillValue(fields[1])"></app-form-field>
              </div>
              <div class="stepper-actions">
                <button mat-button type="button" matStepperPrevious><mat-icon>arrow_back</mat-icon> Zurück</button>
                <button mat-raised-button color="primary" type="button" matStepperNext>Weiter
                  <mat-icon>arrow_forward</mat-icon></button>
              </div>
            </mat-step>

            <!-- Legal Address Step -->
            <mat-step [stepControl]="form" *ngIf="fields[2]">
              <ng-template matStepLabel>Rechtsadresse</ng-template>
              <div class="form-fields-container single-field">
                <app-form-field [field]="fields[2]" [formGroup]="form" [initialValue]="getPrefillValue(fields[2])"></app-form-field>
              </div>
              <div class="stepper-actions">
                <button mat-button type="button" matStepperPrevious><mat-icon>arrow_back</mat-icon> Zurück</button>
                <button mat-raised-button color="primary" type="button" matStepperNext>Weiter
                  <mat-icon>arrow_forward</mat-icon></button>
              </div>
            </mat-step>

            <mat-step [stepControl]="form" *ngIf="fields[3]">
              <ng-template matStepLabel>Hauptsitzadresse</ng-template>
              <div class="form-fields-container single-field">
                <app-form-field [field]="fields[3]" [formGroup]="form" [initialValue]="getPrefillValue(fields[3])"></app-form-field>
              </div>
              <div class="stepper-actions">
                <button mat-button type="button" matStepperPrevious><mat-icon>arrow_back</mat-icon> Zurück</button>
                <button mat-raised-button color="primary" type="button" matStepperNext>Weiter
                  <mat-icon>arrow_forward</mat-icon></button>
              </div>
            </mat-step>
            <!-- Others Step -->
            <mat-step [stepControl]="form" *ngIf="fields.length > 4 || showOptionalButton">
              <ng-template matStepLabel>Sonstige</ng-template>
              <div class="form-fields-container">
                <ng-container *ngFor="let field of fields; let i = index">
                  <app-form-field *ngIf="i >= 4" [field]="field" [formGroup]="form" [initialValue]="getPrefillValue(field)"></app-form-field>
                </ng-container>

                <div class="optional-fields-trigger" *ngIf="showOptionalButton">
                  <button mat-stroked-button color="accent" type="button" (click)="toggleOptionalFields()">
                    <mat-icon>add</mat-icon>
                    Description and Relationships hinzufügen
                  </button>
                </div>
              </div>
              <div class="stepper-actions">
                <button mat-button type="button" matStepperPrevious><mat-icon>arrow_back</mat-icon> Zurück</button>
              </div>
            </mat-step>
          </mat-horizontal-stepper>

          <!-- Default Stepper for non-Legal Person -->
          <mat-horizontal-stepper *ngIf="hasOverflow && !isLegalPerson" #stepper [linear]="false" class="form-stepper">
            <!-- Main Page -->
            <mat-step [stepControl]="form">
              <ng-template matStepLabel>Haupteigenschaften</ng-template>
              <div class="form-fields-container">
                <app-form-field *ngFor="let field of primaryFields" [field]="field" [formGroup]="form"></app-form-field>
              </div>
              <div class="stepper-actions">
                <button mat-raised-button color="primary" type="button" matStepperNext>Weiter
                  <mat-icon>arrow_forward</mat-icon></button>
              </div>
            </mat-step>

            <!-- Overflow Steps: 1 field per page -->
            <mat-step *ngFor="let field of overflowFields" [stepControl]="form">
              <ng-template matStepLabel>{{ field.name || 'Zusätzliches Feld' }}</ng-template>
              <div class="form-fields-container single-field">
                <app-form-field [field]="field" [formGroup]="form"></app-form-field>
              </div>
              <div class="stepper-actions">
                <button mat-button type="button" matStepperPrevious><mat-icon>arrow_back</mat-icon> Zurück</button>
                <button mat-raised-button color="primary" type="button" matStepperNext>Weiter
                  <mat-icon>arrow_forward</mat-icon></button>
              </div>
            </mat-step>
          </mat-horizontal-stepper>

          <mat-divider></mat-divider>

          <div class="form-actions">
            <button mat-button type="button" (click)='onReset()'>
              Formular zurücksetzen
            </button>
            <span class="spacer"></span>
            <button mat-raised-button color="primary" type="submit" *ngIf="!isOnboarding">
              <mat-icon>save</mat-icon>
              Verifiable Credential speichern
            </button>
          </div>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
</div>